import { CSSProperties } from "react"
import { profileIconsPack } from "../../../../consts"
import { Visibility } from "../../headerNavStyles"
import { SxProps } from "@mui/material"
import { Theme } from "@mui/system"

export const sideMenuCont = {
  display: "flex",
  flexDirection: "column",
  minHeight: "327px",
  width: "100vw",
  position: "absolute",
  right: "-8px",
  top: "65px",
  zIndex: 99,
  transition: "all 0.3s ease",
  "@media (min-width: 638px)": {
    right: "0px",
    width: "320px",
  },
}

export const menuBlurCont = {
  position: "fixed",
  width: "100vw",
  height: "100vh",
  cursor: "auto",
  zIndex: -1,
  top: 0,
  right: 0,
}

export const sideMenuItem: SxProps<Theme>  = {
  display: "grid",
  gridTemplate: "1fr / 24px 1fr auto",
  width: "100%",
  height: "auto",
  gap: "8px",
  margin: "8px 0px 0px",
  padding: "10px 16px 10px 12px",
  alignItems: "center",
  color: "var(--Schemes-On-Surface)",
  textAlign: "left",
  textTransform: "none",
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "20px",
  transition: "all 0.3s ease",
  cursor: "pointer",
  letterSpacing: "0.1px",
  background: "transparent",
  "&:hover": {
    color: "var(--Schemes-Primary)",
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
    transition: "all 0.3s ease",
  }
}

export const handleProfileItemStyle = (
  i: number,
  isOpenMenu: boolean,
): CSSProperties => ({
  width: "100%",
  position: "absolute",
  top: `${51 * i + -5}px`,
  right: isOpenMenu ? `${i * 0}px` : `-${(i + 1) * 150}px`,
  background: "var(--Schemes-Surface)",
  opacity: isOpenMenu ? "1" : "0",
  visibility: isOpenMenu ? "visible" : "hidden",
  transition: "all 0.3s ease",
  border: "solid 1px var(--Schemes-Outline-Variant)",
  borderTop: "transparent",
})

export const handleOpenCloseMenu = (isOpen: boolean): CSSProperties => ({
  opacity: isOpen ? "1" : "0",
  visibility: isOpen ? Visibility.visible : Visibility.hidden,
})